import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';

type TimeSeries = {
  title: string;
  content: string;
};

type Props = {
  incidentNo: string;
  incidentType: string;
  telegramTargetAddress: string;
  targetAddressOther: string;
  timeSeries: TimeSeries[];
};

export const IncidentInformation = ({
  incidentNo,
  incidentType,
  telegramTargetAddress,
  targetAddressOther,
  timeSeries,
}: Props) => {
  return (
    <div className="flex flex-col gap-[16px]">
      <SectionTitle text="事案情報" />
      <BorderedContainer>
        <div className="flex flex-col gap-[24px]">
          <div className="flex gap-[40px] xl:gap-[96px]">
            <InfoDisplay title="出動番号" content={incidentNo} />
            <InfoDisplay title="事故種別" content={incidentType} />
            <InfoDisplay title="出動場所" content={telegramTargetAddress} />
            <InfoDisplay title="出動場所建物等" content={targetAddressOther} />
          </div>
          <div className="flex flex-wrap gap-x-[40px] xl:gap-x-[96px] gap-y-[24px]">
            {timeSeries.map(timeSeries => (
              <InfoDisplay
                key={timeSeries.title}
                title={timeSeries.title}
                content={timeSeries.content}
              />
            ))}
          </div>
        </div>
      </BorderedContainer>
    </div>
  );
};
